/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeActivateCommissionPlanRequest, type ActivateCommissionPlanRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans/{commissionPlanId}/activate
 */
export interface ActivateRequestBuilder extends BaseRequestBuilder<ActivateRequestBuilder> {
    /**
     * Switches the plan back on so it can be selected when a statement is generated. Being active is necessary but not sufficient: the plan is only chosen for a given date if its effective range also covers that date, and where two active plans overlap only the one starting most recently is used. Activating changes nothing about statements already generated, which carry the rates they were calculated with. Calling this on a plan that is already active succeeds and leaves it as it was. No request body is required — the body exists only to carry an organization switch for callers who work across several organizations.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ActivateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Switches the plan back on so it can be selected when a statement is generated. Being active is necessary but not sufficient: the plan is only chosen for a given date if its effective range also covers that date, and where two active plans overlap only the one starting most recently is used. Activating changes nothing about statements already generated, which carry the rates they were calculated with. Calling this on a plan that is already active succeeds and leaves it as it was. No request body is required — the body exists only to carry an organization switch for callers who work across several organizations.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ActivateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ActivateRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans/{commissionPlanId}/activate";
/**
 * Metadata for all the requests in the request builder.
 */
export const ActivateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ActivateRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeActivateCommissionPlanRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
